import { createApp } from 'vue'
import LauncherPage from './LauncherPage.vue'
import BootstrapVueNext from 'bootstrap-vue-next';
import {createRouter, createWebHistory} from "vue-router";


const router = createRouter({
    history: createWebHistory("/"),
    routes: [
        {
            path: '/launcher/:uuid',
            name: 'LauncherPage',
            component: () => import('./LauncherPage.vue'),

        },
    ]
})
const app   = createApp(LauncherPage)


    .use(BootstrapVueNext)
    .use(router)

app.mount('#launcher');
export const appInstance = app;